import {
    Edit,
    SimpleForm,
    TextInput,
    useRecordContext,
    required,
    SelectInput,
    NumberInput,
    minValue,
} from 'react-admin';

import { Ce_Blogs } from '../../custom';
import { EditToolbar } from '../../common/EditToolbar';
import { ORGANIZATION_RESOURCE_TYPES } from '../../common/constants';
import { OrganizationAutocomplete } from '../../common/inputs/autoCompleteInputs/OrganizationAutoComplete';
import { KeyValueInput } from '../../common/inputs/KeyValueInput';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionGuard from '../../common/PermissionGuard';

const OrganizationResourcesEdit = () => {
    const { isUpdatable } = useIsPermission('ORGANIZATION_RESOURCE');

    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit mutationMode={'pessimistic'} title={<OrganizationResourcesTitle />}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="title" fullWidth validate={[required()]} />
                    <NumberInput source="displayOrder" fullWidth validate={[minValue(1)]} />
                    <OrganizationAutocomplete alwaysOn validate={[required()]} />
                    <SelectInput
                        source="type"
                        label={'Resource Type'}
                        fullWidth
                        validate={[required()]}
                        choices={ORGANIZATION_RESOURCE_TYPES}
                    />
                    <KeyValueInput source="data" label="Add Config" fullWidth />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    );
};

const OrganizationResourcesTitle = () => {
    const record = useRecordContext<Ce_Blogs>();
    return record ? <span>{record.title}</span> : null;
};

export default OrganizationResourcesEdit;
